import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import supabase from '../../supabaseClient'
import Loader from '../Loader'
import SignupLayout from './SignupLayout'
import {
  academyLoginRedirectState,
  fetchExistingAcademyMembership,
} from '../../utils/existingAcademyCheck'

/**
 * Blocks academy coach signup routes when the signed-in user is already
 * a coach at another academy. Redirects to /academy/login with a popup
 * payload (alreadyInAcademy).
 */
export default function AcademySignupGuard({ children }) {
  const navigate = useNavigate()
  const [ready, setReady] = useState(false)

  useEffect(() => {
    let cancelled = false

    async function run() {
      const {
        data: { session },
      } = await supabase.auth.getSession()

      if (!session?.user) {
        if (!cancelled) setReady(true)
        return
      }

      const membership = await fetchExistingAcademyMembership(session.user.id)
      if (!membership) {
        if (!cancelled) setReady(true)
        return
      }

      if (!cancelled) {
        navigate('/academy/login', {
          replace: true,
          state: academyLoginRedirectState(membership.academyName),
        })
      }
    }

    run()
    return () => {
      cancelled = true
    }
  }, [navigate])

  if (!ready) {
    return (
      <SignupLayout showLogin={false}>
        <div className="flex flex-col items-center justify-center pt-12">
          <Loader size={28} className="text-[var(--signup-bg-base)]" />
        </div>
      </SignupLayout>
    )
  }

  return children
}
